import React, { useEffect, useState } from "react";
import DashboardNavbar from "./DashboardNavbar";
import Footer from "./footer";
import "../style.css";
import { getData } from "../api/protectedApi";
import { Link } from "react-router-dom";
import {
  FaLifeRing,
  FaUsers,
  FaHandHoldingUsd,
  FaCoins,
  FaChartBar,
  FaMoneyBillWave,
  FaUserPlus,
  FaSpinner,
} from "react-icons/fa";
import { toast } from "react-toastify";



const ReferralList = () => {
  const [userName, setUserName] = useState("");
  const [dashboard, setDashboard] = useState({});
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);     
  const [perPage, setPerPage] = useState(5); 

  // Fetch referral list
  const fetchReferralList = async () => {
    try {
      setLoading(true);

      const response = await getData(
        `/directs?per_page=${perPage}&page=${page}`
      );


      if (response?.data?.data) {
        setReferrals(response.data.data);
      } else {
        setReferrals([]);
      }
    } catch (error) {
      console.error("Error fetching referral list:", error);
      setReferrals([]);
    } finally {
      setLoading(false);
    }
  };

  const getUserProfile = async () => {
    try {
      const res = await getData("/profile");
      if (res?.data?.user_data?.name) {
        setUserName(res.data.user_data.name);
      }
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };


  const loadData = async () => {
    try {
      const res = await getData("/dashboard");
      if (res?.data?.data) {
        setDashboard(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to load dashboard");
    }
  };
  useEffect(() => {
    fetchReferralList();
    getUserProfile();
    loadData()
  }, [page, perPage]);

  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        color: "#ffffff",
        paddingTop: "12px",
      }}
    >
      {/* Navbar */}
      <DashboardNavbar />

      {/* Header */}
      <section>
        <div className="container pt-5">
          <div className="mb-4">
            <div className="welcome">Welcome to Hifi Internationals</div>
            <div className="hello">
              Hello, {userName || "User"}
            </div>
          </div>
        </div>
      </section>

      {/* Pool Info */}
      <section>
        <div
          className="container-fluid py-3"
          style={{ backgroundColor: "#141245" }}
        >
          <div className="container">
            <div className="mb-4">
              <div className="hifi1-race-label">Active : $30</div>
              <div className="hifi1-race-title">Activation Pool</div>
            </div>

            <div className="row g-4">
              <div className="col-lg-3 col-md-6">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaSpinner size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Status</div>
                  <div className="hifi1-card-value">
                    {dashboard?.pool_status}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaUserPlus size={40} />
                  </div>
                  <div className="hifi1-card-label">Total Referrals</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directs || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon orange">
                    < FaMoneyBillWave size={40} />
                  </div>
                  <div className="hifi1-card-label">Referral Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directIncome || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon darkblue">
                    <FaChartBar size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.poolIncome || 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links */}
      <section className="hifi1section py-5">
        <div className="container">
          <div className="row g-4 justify-content-center hifi1section-2">

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/activationpool" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaLifeRing size={40} />
                  <span>POOL INFO</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/referraltree" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaUsers size={40} />
                  <span>LEVEL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/directincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaHandHoldingUsd size={40} />
                  <span>REFERRAL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaCoins size={40} />
                  <span>POOL INCOME</span>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>


      {/* Referral Table */}
      <section className="py-4">
        <div className="container">
          <div className="directs-wrapper">
            <h3 className="directs-title mb-3">Referrals List</h3>

            <div className="table-responsive">
              <table className="table directs-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ETH Address</th>
                    <th>User ID</th>
                    <th>Joining Time</th>
                  </tr>
                </thead>

                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="4" className="text-center text-white">
                        Loading...
                      </td>
                    </tr>
                  )}

                  {!loading && referrals.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center text-white">
                        No referrals found
                      </td>
                    </tr>
                  )}

                  {!loading &&
                    referrals.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="text-break">
                          {item.eth_address || "-"}
                        </td>
                        <td>{item.user_id || "-"}</td>
                        <td>{item.registration_date || "-"}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReferralList;
